<template>
  <div class="layout">
    <div class="layout-top">
      <TheHeader class="w-full" :isAdmin="isAdminPath" />
    </div>
    <div class="layout-main">
      <TheNavBarMobile :isAdmin="isAdminPath" :isNavOpen="isNavOpen" @close="closeNav" />
      <div class="layout-main-left">
        <TheNavBarDesktop :isAdmin="isAdminPath" />
      </div>
      <div class="relative layout-main-right">
        <main class="layout-main-right-main" :class="[padded && 'px-4 sm:px-8']">
          <slot></slot>
        </main>
        <div class="layout-main-right-footer">
          <TheFooter />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { isAdminPath } from '@/utils';

import TheNavBarDesktop from './TheNavBarDesktop';
import TheNavBarMobile from './TheNavBarMobile';
import TheHeader from './TheHeader';
import TheFooter from './TheFooter';

export default {
  name: 'Layout',
  components: { TheHeader, TheFooter, TheNavBarDesktop, TheNavBarMobile },
  data() {
    return {
      padded: false,
    };
  },
  computed: mapState({
    isNavOpen: state => state.isNavOpen,
    isAdminPath() {
      const path = this.$route.path;
      return isAdminPath(path);
    },
  }),
  watch: {
    $route(to) {
      const re = /(\/|\/orders)$/gi;
      this.padded = !re.test(to.path);

      // close nav sidebar on route change
      this.closeNav();
    },
  },
  methods: {
    closeNav() {
      this.isNavOpen && this.$store.commit('closeMobileNav');
    },
  },
  mounted() {
    const re = /(\/|\/orders)$/gi;
    this.padded = !re.test(this.$router.history.current.path);
  },
};
</script>
